import React from "react";
import PropTypes from "prop-types";
import { Flex } from "@chakra-ui/react";

function Rail({
  id,
  children,
  height,
  innerDivClasses,
  width,
  addComponent,
  alwaysShowTrack,
  railStyles,
}) {
  let classes = "inner-div ";
  if (innerDivClasses) {
    classes += innerDivClasses;
  }

  return (
    <Flex
      minW="100%"
      transition="background 0.3s"
      align="center"
      py={2}
      position="relative"
      background={alwaysShowTrack ? "brand.border-color" : "none"}
      _hover={{
        background: "brand.border-color",
      }}
      sx={{
        ".inner-div": {
          display: "flex",
          position: "relative",
        },
        ...railStyles,
      }}
    >
      <div id={id} className={classes} style={{ height, width }}>
        {children}
      </div>
      {addComponent}
    </Flex>
  );
}

Rail.defaultProps = {
  width: "100%",
  alwaysShowTrack: false,
};

Rail.propTypes = {
  id: PropTypes.string.isRequired,
  addComponent: PropTypes.node,
  alwaysShowTrack: PropTypes.bool,
  railStyles: PropTypes.object,
  innerDivClasses: PropTypes.string,
};

export default Rail;
